var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c("div", { staticClass: "header" }, [
            _c(
              "div",
              { staticClass: "activity_area" },
              [
                _c("div", { staticClass: "activity_title" }, [
                  _vm._v("活动标题"),
                ]),
                _vm._v(" "),
                _c("el-input", {
                  staticStyle: { width: "300px" },
                  attrs: { placeholder: "请输入活动标题" },
                  model: {
                    value: _vm.activity.title,
                    callback: function ($$v) {
                      _vm.$set(_vm.activity, "title", $$v)
                    },
                    expression: "activity.title",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "btn-area" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.handlePreview },
                  },
                  [_vm._v("预览")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.handleSave()
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "activity_page" }, [
            _c(
              "div",
              { staticClass: "left-board" },
              _vm._l(_vm.leftComponents, function (item, index) {
                return _c("div", { key: index }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(item.title)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "components-list" },
                    _vm._l(item.list, function (_item, _index) {
                      return _c(
                        "div",
                        {
                          key: _index,
                          staticClass: "components-item",
                          on: {
                            click: function ($event) {
                              return _vm.addComponent(_item)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "icon-area" }, [
                            _c("i", { class: _item.icon }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "components-title" }, [
                            _vm._v(_vm._s(_item.title)),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "center-board" },
              _vm._l(_vm.centerComponents, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "components-item",
                    class: { select_active: item.select },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "delete-icon",
                        attrs: { title: "删除" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.deleteComponent(index)
                          },
                        },
                      },
                      [_c("i", { staticClass: "el-icon-delete" })]
                    ),
                    _vm._v(" "),
                    item.type === 2
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "image-component",
                              on: {
                                click: function ($event) {
                                  return _vm.selectComponent(index, item)
                                },
                              },
                            },
                            [
                              item.image
                                ? _c("img", {
                                    attrs: { src: item.image, alt: "图片组件" },
                                  })
                                : _c("div", { staticClass: "image-empty" }, [
                                    _vm._v("请设置图片"),
                                  ]),
                            ]
                          ),
                        ]
                      : item.type === 3
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "goods-component",
                              on: {
                                click: function ($event) {
                                  return _vm.selectComponent(index, item)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "goods_list" },
                                [
                                  item.product_list && item.product_list.length
                                    ? _vm._l(
                                        item.product_list,
                                        function (item, itemIndex) {
                                          return _c(
                                            "div",
                                            {
                                              key: itemIndex,
                                              staticClass: "goods_item",
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "goods_image",
                                                attrs: { src: item.image },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "goods_name" },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(item.storeName) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "goods_price" },
                                                [
                                                  _vm._v(
                                                    "￥" + _vm._s(item.price)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "goods-empty" },
                                        [_vm._v("请设置商品")]
                                      ),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "right-board" }, [
              _c("div", { staticClass: "title" }, [_vm._v("模块配置")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "components-list" },
                _vm._l(_vm.centerComponents, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "components-item" },
                    [
                      _vm.selectType === "image" &&
                      index === _vm.currentActivityIndex
                        ? _c("div", { staticClass: "info" }, [
                            _c("div", { staticClass: "info-item" }, [
                              _c("span", [_vm._v("活动图片")]),
                              _vm._v(" "),
                              _c("div", { staticClass: "input-box" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "img-box flex justify-center align-center",
                                    on: {
                                      click: function ($event) {
                                        return _vm.modalPicTap(
                                          "1",
                                          "activity",
                                          index,
                                          true
                                        )
                                      },
                                    },
                                  },
                                  [
                                    item.image
                                      ? _c("img", {
                                          attrs: { src: item.image, alt: "" },
                                        })
                                      : _c("div", { staticClass: "upLoad" }, [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-camera cameraIconfont",
                                          }),
                                        ]),
                                  ]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-item" }, [
                              _c("span", [_vm._v("活动链接")]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "input-box",
                                  on: {
                                    click: function ($event) {
                                      return _vm.getLink(index)
                                    },
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请填写链接" },
                                    model: {
                                      value: item.url,
                                      callback: function ($$v) {
                                        _vm.$set(item, "url", $$v)
                                      },
                                      expression: "item.url",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectType === "goods" &&
                      index === _vm.currentActivityIndex
                        ? _c("div", { staticClass: "info" }, [
                            _c("div", { staticClass: "info-item" }, [
                              _c("span", [_vm._v("商品")]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "input-box" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "goods_list" },
                                    _vm._l(
                                      item.product_list,
                                      function (goods_item, goods_index) {
                                        return _c(
                                          "div",
                                          {
                                            key: goods_index,
                                            staticClass: "goods_list_item",
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "goods_img",
                                              attrs: {
                                                src: goods_item.image,
                                                alt: "",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-circle-close goods_close",
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.goodsDelete(
                                                    goods_item,
                                                    goods_index
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        size: "mini",
                                        icon: "el-icon-circle-plus-outline",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeGoods(index)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    选择商品\n                  "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "页面预览",
                visible: _vm.previewVisible,
                width: "420px",
                top: "40px",
                "close-on-click-modal": false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.previewVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "preview-board" },
                _vm._l(_vm.centerComponents, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "preview-item" },
                    [
                      item.type === 2
                        ? [
                            _c(
                              "div",
                              { staticClass: "image-component" },
                              [
                                _c("el-image", {
                                  attrs: {
                                    src: item.image,
                                    alt: "",
                                    mode: "widthFix",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        : item.type === 3
                        ? [
                            _c("div", { staticClass: "goods-component" }, [
                              _c(
                                "div",
                                { staticClass: "goods_list" },
                                [
                                  _vm._l(
                                    item.product_list,
                                    function (goods, idx) {
                                      return _c(
                                        "div",
                                        { key: idx, staticClass: "goods_item" },
                                        [
                                          _c("img", {
                                            staticClass: "goods_image",
                                            attrs: { src: goods.image },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "goods_name" },
                                            [_vm._v(_vm._s(goods.storeName))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "goods_price" },
                                            [_vm._v("￥" + _vm._s(goods.price))]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                }),
                0
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("linkaddress", { ref: "linkaddres", on: { linkUrl: _vm.linkUrl } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }